angular.module('bmsApp.trugreen.job').factory('TGSalesTypeSvc', function ($q,
																		   CRUDSvc) {

	return {
		options: function (params) {
			return CRUDSvc.get('api/trugreen/salesType/options', params);
		}
	};

});
